import React from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';

import { UndoOutlined, SaveOutlined } from '@ant-design/icons';

import { Button, Row, Col, Typography } from 'antd';
import {
  FormikSelect,
  FormikButton,
  FormikTextNumber,
  FormikInputNumber,
  FormikInput
} from '../../Components/Formik';
import ProdIssDetailActions from '../../Stores/ProdIssDetail/Actions';

const { Text } = Typography;

class DetailForm extends React.PureComponent {
  constructor() {
    super();

    this.handleSearchDtlLocation = this.handleSearchDtlLocation.bind(this);

    this.handleSearchDtlItem = this.handleSearchDtlItem.bind(this);
    this.handleSearchDtlUom = this.handleSearchDtlUom.bind(this);

    this.handleChangeDtlItem = this.handleChangeDtlItem.bind(this);
    this.handleChangeDtlUom = this.handleChangeDtlUom.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate() {}

  componentWillUnmount() {}

  handleSearchDtlLocation(form, value) {
    const { fetchDtlLocationOptions } = this.props;

    fetchDtlLocationOptions(value);
  }

  handleSearchDtlItem(form, value) {
    const { fetchDtlItemOptions } = this.props;

    fetchDtlItemOptions(value);
  }

  handleSearchDtlUom(form, value) {
    const { fetchDtlUomOptions } = this.props;
    const { values } = form;

    fetchDtlUomOptions(values.item_select2.value, value);
  }

  handleChangeDtlItem(form, value) {
    // params: form, value, option
    const { hdrId, changeDtlItem } = this.props;

    changeDtlItem(form, hdrId, value);
  }

  handleChangeDtlUom(form, value) {
    // params: form, value, option
    const { hdrId, changeDtlUom } = this.props;
    const { values } = form;

    changeDtlUom(form, hdrId, values.item_select2.value, value);
  }

  render() {
    const {
      intl,
      hdrId,
      documentHeader,
      documentDetail,
      dtlLocationIsLoading,
      dtlLocationOptions,
      dtlItemIsLoading,
      dtlItemOptions,
      dtlUomIsLoading,
      dtlUomOptions,
      updateDetails,
      createDetail,
      documentIsLoading
    } = this.props;

    const disabled = documentHeader && documentHeader.doc_status >= 50;
    return (
      <Formik
        enableReinitialize
        initialValues={documentDetail}
        onSubmit={(values, formikBag) => {
          // remove the submit_action field
          const processedValues = { ...values };
          delete processedValues.submit_action;

          if (values.id > 0) {
            updateDetails(formikBag, hdrId, [processedValues]);
          } else {
            createDetail(formikBag, hdrId, processedValues);
          }
        }}
        validationSchema={Yup.object().shape({
          location_select2: Yup.object().shape({
            value: Yup.number().min(1, intl.formatMessage({ id: 'location_is_required' }))
          }),
          item_select2: Yup.object().shape({
            value: Yup.number().min(1, intl.formatMessage({ id: 'item_is_required' }))
          }),
          qty: Yup.number().moreThan(-1, intl.formatMessage({ id: 'qty_must_be_positive' })),
          uom_select2: Yup.object().shape({
            value: Yup.number().min(1, intl.formatMessage({ id: 'uom_is_required' }))
          })
        })}
      >
        {({
          values,
          // handleChange,
          // errors,
          // setFieldTouched,
          dirty,
          // touched,
          isSubmitting,
          // isValid,
          handleSubmit,
          handleReset
        }) => (
          <Form>
            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'location' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="location_select2"
                  component={FormikSelect}
                  showArrow
                  filterOption={false}
                  onSearch={this.handleSearchDtlLocation}
                  notFoundContent={null}
                  loading={dtlLocationIsLoading}
                  options={dtlLocationOptions}
                  disabled={disabled}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'item' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="item_select2"
                  component={FormikSelect}
                  showArrow
                  filterOption={false}
                  onSearch={this.handleSearchDtlItem}
                  notFoundContent={null}
                  loading={dtlItemIsLoading}
                  options={dtlItemOptions}
                  disabled={disabled}
                  onChange={this.handleChangeDtlItem}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'desc_01' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field name="desc_01" component={FormikInput} disabled={disabled} />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'desc_02' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field name="desc_02" component={FormikInput} disabled={disabled} />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'qty' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={8}>
                <Field
                  name="qty"
                  component={FormikInputNumber}
                  precision={values.qty_scale || 0}
                  disabled={disabled}
                />
              </Col>
              <Col span={12} />
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'uom' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={8}>
                <Field
                  name="uom_select2"
                  component={FormikSelect}
                  showArrow
                  filterOption={false}
                  onSearch={this.handleSearchDtlUom}
                  notFoundContent={null}
                  loading={dtlUomIsLoading}
                  options={dtlUomOptions}
                  disabled={disabled}
                  onChange={this.handleChangeDtlUom}
                />
              </Col>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'rate' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={8}>
                <Field
                  name="uom_rate"
                  component={FormikTextNumber}
                  minimumfractiondigits={6}
                  maximumfractiondigits={6}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'sale_price' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={8}>
                <Field
                  name="sale_price"
                  component={FormikInputNumber}
                  disabled={disabled}
                  precision={parseInt(process.env.REACT_APP_DECIMAL_SCALE, 10)}
                />
              </Col>

              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'price_disc' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={8}>
                <Field
                  name="price_disc"
                  component={FormikInputNumber}
                  disabled={disabled}
                  precision={parseInt(process.env.REACT_APP_DECIMAL_SCALE, 10)}
                  max={100}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'disc_val_01' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={8}>
                <Field
                  name="dtl_disc_val_01"
                  component={FormikInputNumber}
                  disabled={disabled}
                  precision={parseInt(process.env.REACT_APP_DECIMAL_SCALE, 10)}
                />
              </Col>

              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'disc_perc_01' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={8}>
                <Field
                  name="dtl_disc_perc_01"
                  component={FormikInputNumber}
                  disabled={disabled}
                  precision={parseInt(process.env.REACT_APP_DECIMAL_SCALE, 10)}
                  max={100}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'disc_val_02' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={8}>
                <Field
                  name="dtl_disc_val_02"
                  component={FormikInputNumber}
                  disabled={disabled}
                  precision={parseInt(process.env.REACT_APP_DECIMAL_SCALE, 10)}
                />
              </Col>

              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'disc_perc_02' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={8}>
                <Field
                  name="dtl_disc_perc_02"
                  component={FormikInputNumber}
                  disabled={disabled}
                  precision={parseInt(process.env.REACT_APP_DECIMAL_SCALE, 10)}
                  max={100}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'disc_val_03' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={8}>
                <Field
                  name="dtl_disc_val_03"
                  component={FormikInputNumber}
                  disabled={disabled}
                  precision={parseInt(process.env.REACT_APP_DECIMAL_SCALE, 10)}
                />
              </Col>

              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'disc_perc_03' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={8}>
                <Field
                  name="dtl_disc_perc_03"
                  component={FormikInputNumber}
                  disabled={disabled}
                  precision={parseInt(process.env.REACT_APP_DECIMAL_SCALE, 10)}
                  max={100}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'disc_val_04' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={8}>
                <Field
                  name="dtl_disc_val_04"
                  component={FormikInputNumber}
                  disabled={disabled}
                  precision={parseInt(process.env.REACT_APP_DECIMAL_SCALE, 10)}
                />
              </Col>

              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'disc_perc_04' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={8}>
                <Field
                  name="dtl_disc_perc_04"
                  component={FormikInputNumber}
                  disabled={disabled}
                  precision={parseInt(process.env.REACT_APP_DECIMAL_SCALE, 10)}
                  max={100}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'tax_perc_01' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={8}>
                <Field
                  name="dtl_tax_perc_01"
                  component={FormikInputNumber}
                  disabled={disabled}
                  precision={parseInt(process.env.REACT_APP_DECIMAL_SCALE, 10)}
                />
              </Col>
              <Col span={12} />
            </Row>

            <Row type="flex" justify="end" gutter={[0, 16]}>
              <Col span={5}>
                <Button
                  type="primary"
                  disabled={!dirty}
                  loading={isSubmitting || documentIsLoading}
                  onClick={handleReset}
                  icon={<UndoOutlined />}
                >
                  {intl.formatMessage({ id: 'reset' })}
                </Button>
                <Field
                  type="primary"
                  name="submit_action"
                  value="update"
                  component={FormikButton}
                  disabled={disabled}
                  loading={isSubmitting || documentIsLoading}
                  onClick={handleSubmit}
                  label={intl.formatMessage({
                    id: values.id > 0 ? 'update' : 'create'
                  })}
                  icon={<SaveOutlined />}
                />
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    );
  }
}

DetailForm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  updateDetails: PropTypes.func,
  createDetail: PropTypes.func,
  hdrId: PropTypes.number,
  documentHeader: PropTypes.shape({
    doc_status: PropTypes.number
  }),
  documentDetail: PropTypes.shape({}),
  documentIsLoading: PropTypes.bool,

  fetchDtlLocationOptions: PropTypes.func,
  dtlLocationIsLoading: PropTypes.bool,
  dtlLocationOptions: PropTypes.arrayOf(PropTypes.object),

  fetchDtlItemOptions: PropTypes.func,
  changeDtlItem: PropTypes.func,
  dtlItemIsLoading: PropTypes.bool,
  dtlItemOptions: PropTypes.arrayOf(PropTypes.object),

  fetchDtlUomOptions: PropTypes.func,
  changeDtlUom: PropTypes.func,
  dtlUomIsLoading: PropTypes.bool,
  dtlUomOptions: PropTypes.arrayOf(PropTypes.object)
};

DetailForm.defaultProps = {
  intl: {},
  updateDetails() {},
  createDetail() {},
  hdrId: 0,
  documentHeader: { doc_status: 3 },
  documentDetail: {},
  documentIsLoading: false,

  fetchDtlLocationOptions() {},
  dtlLocationIsLoading: false,
  dtlLocationOptions: [],

  fetchDtlItemOptions() {},
  fetchDtlUomOptions() {},
  changeDtlItem() {},
  changeDtlUom() {},
  dtlItemIsLoading: false,
  dtlItemOptions: [],
  dtlUomIsLoading: false,
  dtlUomOptions: []
};

const mapStateToProps = state => ({
  hdrId: state.prodIssDetail.hdrId,
  documentHeader: state.prodIssDetail.documentHeader,
  documentDetail: state.prodIssDetail.documentDetail,
  documentIsLoading: state.prodIssDetail.documentIsLoading,

  dtlLocationIsLoading: state.prodIssDetail.dtlLocationIsLoading,
  dtlLocationOptions: state.prodIssDetail.dtlLocationOptions,

  dtlItemIsLoading: state.prodIssDetail.dtlItemIsLoading,
  dtlItemOptions: state.prodIssDetail.dtlItemOptions,

  dtlUomIsLoading: state.prodIssDetail.dtlUomIsLoading,
  dtlUomOptions: state.prodIssDetail.dtlUomOptions
});

const mapDispatchToProps = dispatch => ({
  updateDetails: (formikBag, hdrId, documentDetails) =>
    dispatch(ProdIssDetailActions.prodIssDetailUpdateDetails(formikBag, hdrId, documentDetails)),
  createDetail: (formikBag, hdrId, documentDetail) =>
    dispatch(ProdIssDetailActions.prodIssDetailCreateDetail(formikBag, hdrId, documentDetail)),

  fetchDtlLocationOptions: search =>
    dispatch(ProdIssDetailActions.prodIssDetailFetchDtlLocationOptions(search)),

  fetchDtlItemOptions: search =>
    dispatch(ProdIssDetailActions.prodIssDetailFetchDtlItemOptions(search)),
  changeDtlItem: (formikBag, hdrId, itemId) =>
    dispatch(ProdIssDetailActions.prodIssDetailChangeDtlItem(formikBag, hdrId, itemId)),

  fetchDtlUomOptions: (itemId, search) =>
    dispatch(ProdIssDetailActions.prodIssDetailFetchDtlUomOptions(itemId, search)),
  changeDtlUom: (formikBag, hdrId, itemId, uomId) =>
    dispatch(ProdIssDetailActions.prodIssDetailChangeDtlUom(formikBag, hdrId, itemId, uomId))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(DetailForm));
